import { useState } from 'react'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'

export const SelectedItem = ({ item, index, onRemoveItem }) => {
  const [isHover, setIsHover] = useState(false)

  const onMouseEnter = () => {
    setIsHover(true)
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  return (
    <Element
      className="dFlex alignItemsCenter justifyContentBetween"
      style={{
        padding: '4px 12px',
        backgroundColor: isHover
          ? '#C8E3FF'
          : index % 2 === 0
          ? '#F9F9F9'
          : '#FFFFFF',
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <TextEllipsisStaticLine
        text={item.organizationName}
        lineClamp={2}
        isI18n={false}
      />

      {isHover && (
        <div
          className="dFlex alignItemsCenter ml2"
          onClick={() => onRemoveItem(item)}
        >
          <Icon
            className="icon-delete"
            style={{ fontSize: 10, color: '#9c9c9c' }}
          />
        </div>
      )}
    </Element>
  )
}
